import React from 'react';
import { WhatsAppIcon } from './ContactIcons';

const FloatingWhatsApp = () => {
  return (
    <a
      className="floating-whatsapp"
      href="https://wa.me/916383860220"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with S4CoconutExports on WhatsApp"
    >
      <WhatsAppIcon className="floating-whatsapp-icon" />
      <span>WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
